<div class="wrapper d-flex flex-column h-100 w-100" *ngIf="!isLoading; else loading">
	<div class="overview mb-auto" *ngIf="isEDP; else ec2Breakdown">
		<h3 class="title mb-2">Plan Overview</h3>
		<div class="d-flex align-items-center mb-2">
			<span class="text mr-2">Workload drop tolerance</span>
			<app-circle-info-tooltip [toolTipText]="infoMessage" placement="top"></app-circle-info-tooltip>
		</div>
		<div class="d-flex flex-column mb-4">
			<div class="d-flex align-items-center">
				<div class="input-block d-flex align-items-center">
					<input
						type="number"
						class="input-block__value"
						[class.invalid]="!!getFormControl('flexibility').errors"
						[formControl]="getFormControl('flexibility')"
					/>
					<div class="input-block__symbol">%</div>
				</div>
				<div class="recommended-block d-flex align-items-center">
					<span class="recommended-block__icon mr-2"></span>
					<span>{{ potentialSaveData?.defaultFlexibility | percent }} recommended</span>
				</div>
			</div>
			<div class="error mt-2" *ngIf="errorMessage">{{ errorMessage }}</div>
		</div>
		<app-coverage-plan
			[data]="potentialSaveData"
			[isZestyDomain]="isZestyDomain"
			[form]="form"
			(applyChanges)="submitForm()"
		></app-coverage-plan>
		<button
			data-test-id="psSavingsGraphBtn"
			type="button"
			class="btn btn-main mx-auto mt-4"
			(click)="changeModalView(potentialSaveModalView.SAVINGS_GRAPH)"
		>
			Savings graph
		</button>
	</div>

	<div class="separator w-100 m-0 mt-2"></div>
	<!-- Links -->
	<div class="footer-links d-flex flex-wrap mt-auto">
		<button
			type="button"
			class="link-zesty--external"
			data-test-id="existing-ris-sp-button"
			(click)="changeModalView(potentialSaveModalView.RI_SP_TABLE)"
		>
			Existing RIs & SP’s
			<img ngSrc="/assets/icons/popout_icon.svg" width="9" height="9" alt="external link icon" />
		</button>
		<button
			type="button"
			class="link-zesty--external"
			data-test-id="aws-cost-explorer-button"
			(click)="openAwsCostExplorerLink()"
		>
			AWS Cost Explorer
			<img ngSrc="/assets/icons/popout_icon.svg" width="9" height="9" alt="external link icon" />
		</button>
		<button
			data-test-id="deepdive-renewal-button"
			type="button"
			class="link-zesty--external"
			*ngIf="!isEDP"
			(click)="changeModalView(potentialSaveModalView.DEEPDIVE_RENEWAL)"
		>
			Deep dive renewal over time
			<img ngSrc="/assets/icons/popout_icon.svg" width="9" height="9" alt="external link icon" />
		</button>
		<ng-container *ngIf="isAllocationsAndLinuxTabsAllowed && isZestyEmployee">
			<button
				data-test-id="sp-allocation-button"
				type="button"
				class="link-zesty--external"
				*ngIf="!isEDP"
				(click)="changeModalView(potentialSaveModalView.SP_ALLOCATION)"
			>
				SP allocation
				<img ngSrc="/assets/icons/popout_icon.svg" width="9" height="9" alt="external link icon" />
			</button>
			<button
				data-test-id="linux-uncovered-button"
				type="button"
				class="link-zesty--external"
				(click)="changeModalView(potentialSaveModalView.LINUX_UNCOVERED)"
			>
				Linux uncovered
				<img ngSrc="/assets/icons/popout_icon.svg" width="9" height="9" alt="external link icon" />
			</button>
		</ng-container>
	</div>
</div>

<ng-template #ec2Breakdown>
	<div class="ec2-breakdowns mb-auto">
		<h3 class="title mb-3">EC2 Breakdown</h3>
		<div class="separator w-100 m-0"></div>
		<div class="breakdowns w-100">
			<div class="breakdowns__item d-flex align-items-center justify-content-start w-100">
				<div class="breakdowns__item-value flex-shrink-0">
					{{ coveringSavingsValue | currency : 'USD' : 'symbol' : '1.0-0' }}
				</div>
				<div class="breakdowns__item-text">{{ coveringSavingsText }}</div>
			</div>
			<div class="separator w-100 m-0"></div>
			<div class="breakdowns__item d-flex align-items-center justify-content-start w-100">
				<div class="breakdowns__item-value flex-shrink-0">
					{{ reallocatingSavingsValue | currency : 'USD' : 'symbol' : '1.0-0' }}
				</div>
				<div class="breakdowns__item-text">{{ reallocatingSavingsText }}</div>
			</div>
			<div class="separator w-100 m-0"></div>
		</div>
		<div class="total-savings w-100">
			<div class="total-savings__title">{{ isMonthlyState ? 'Monthly' : 'Annual' }}</div>
			<div class="total-savings__value">
				{{ savings | currency : 'USD' : 'symbol' : '1.0-0' }}
			</div>
		</div>
	</div>
</ng-template>

<ng-template #loading>
	<div class="position-relative spinner-wrapper overflow-hidden h-100 w-100">
		<app-spinner></app-spinner>
	</div>
</ng-template>
